<template lang="pug">
  section.content
    Decades

</template>

<script>
  import Decades from '@/components/timeline/Decades'

  export default  {
    name: 'basecontent',
    components: {
      Decades
    },
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
  .content {
    padding: 1rem;
    @media screen and (max-width: 900px){
      padding: 0 1rem;
    }
  }
</style>
